import { useEffect, useState } from "react";
import Header from "@/components/header";
import HeroSection from "@/components/hero-section";
import ServicesSection from "@/components/services-section";
import ExperienceSection from "@/components/experience-section";
import StatsSection from "@/components/stats-section";
import DriversSection from "@/components/drivers-section";
import VacanciesSection from "@/components/vacancies-section";
import ApplicationForm from "@/components/application-form";
import TestimonialsSection from "@/components/testimonials-section";
import ContactSection from "@/components/contact-section";
import Footer from "@/components/footer";
import { apiClient } from "@/lib/api";
import type { Vacancy } from "@shared/types";

export default function HomePage() {
  const [selectedVacancyId, setSelectedVacancyId] = useState<number | null>(null);
  const [vacancies, setVacancies] = useState<Vacancy[]>([]);

  useEffect(() => {
    apiClient.vacancies
      .list()
      .then((res) => setVacancies(res.data as Vacancy[]))
      .catch(() => {});
  }, []);

  return (
    <main className="min-h-screen bg-background">
      <Header />
      <HeroSection />
      <ServicesSection />
      <ExperienceSection />
      <StatsSection />
      <DriversSection />
      <VacanciesSection onApply={setSelectedVacancyId} />
      <ApplicationForm vacancyId={selectedVacancyId} vacancies={vacancies} />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
